export const getHashCode = (username = 'NZIE5000_') => {
  return username
}
